import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { AboutUs, FAQ, Gallery, Home, Href, Profile } from "../../../../Constants/Constants";
import { SimpleNavProps } from "../../../../Types/UiKitsType";

const AnimatedHorizontalTabsNav: React.FC<SimpleNavProps> = ({ basicTab, setBasicTab }) => {
  return (
    <Nav tabs className="nav-primary " id="bottom-tab2">
      <NavItem>
        <NavLink href={Href} className={`tab-primary ${basicTab === "1" ? "active" : ""}`} onClick={() => setBasicTab("1")}>
          <i className="icofont icofont-building-alt" /><span>{Home}</span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink href={Href} className={`tab-primary ${basicTab === "2" ? "active" : ""}`} onClick={() => setBasicTab("2")}>
          <i className="icofont icofont-building-alt" /><span>{Profile}</span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink href={Href} className={`tab-primary ${basicTab === "3" ? "active" : ""}`} onClick={() => setBasicTab("3")}>
          <i className="icofont icofont-building-alt" /><span>{AboutUs}</span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink href={Href} className={`tab-primary ${basicTab === "4" ? "active" : ""}`} onClick={() => setBasicTab("4")}>
          <i className="icofont icofont-building-alt" /><span>{Gallery}</span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink href={Href} className={`tab-primary ${basicTab === "5" ? "active" : ""}`} onClick={() => setBasicTab("5")}>
          <i className="icofont icofont-building-alt" /><span>{FAQ}</span>
        </NavLink>
      </NavItem>
    </Nav>
  );
};
export default AnimatedHorizontalTabsNav;
